import { render } from "./ShadowsPage.vue?vue&type=template&id=0b345ba8&ts=true"
import script from "./ShadowsPage.vue?vue&type=script&lang=ts"
export * from "./ShadowsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__